import { Injectable } from '@angular/core';
import {
  BaseService,
  Tournament,
  TournamentApi,
  TournamentSeasonApi, TournamentStage, TournamentStageTeam, TournamentTeam
} from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_STAGES_KEY = 'stages';
const STORE_SELECTED_STAGE_KEY = 'selectedStage';
const STORE_TOURNAMENT_TEAMS_KEY = 'tournamentTeams';
const STORE_TOURNAMENT_STAGE_TEAMS_KEY = 'tournamentStageTeams';

@Injectable()
export class TournamentStageWidgetService extends BaseService {
  private tournament: Tournament;
  tournamentId: number;

  get stages$(): Observable<TournamentStage[]> {
    return this.store.get(STORE_STAGES_KEY);
  }

  get selectedStage$(): Observable<TournamentStage> {
    return this.store.get(STORE_SELECTED_STAGE_KEY);
  }

  get teams$(): Observable<TournamentTeam[]> {
    return this.store.get(STORE_TOURNAMENT_TEAMS_KEY);
  }

  get stageTeams$(): Observable<TournamentStageTeam[]> {
    return this.store.get(STORE_TOURNAMENT_STAGE_TEAMS_KEY);
  }

  constructor(
    private tournamentSeasonApi: TournamentSeasonApi,
    private tournamentApi: TournamentApi,
  ) {
    super();
  }

  async initialize(tournament: Tournament): Promise<any> {
    this.tournament = tournament;
    this.tournamentId = tournament.id;
    return await Promise.all([this.getTeams(), this.getStageTeams(), this.getStages()]);
  }

  async setStage(stage: TournamentStage): Promise<any> {
    this.store.save(STORE_SELECTED_STAGE_KEY, stage);
  }

  async getStages(): Promise<TournamentStage[]> {
    const stages = await this.tournamentApi.getTournamentStages(this.tournamentId);
    this.store.save(STORE_STAGES_KEY, stages);
    return stages;
  }

  async getTeams(): Promise<TournamentTeam[]> {
    const teams = await this.tournamentApi.getTeams(this.tournamentId);
    this.store.save(STORE_TOURNAMENT_TEAMS_KEY, teams);
    return teams;
  }

  async getStageTeams(): Promise<TournamentStageTeam[]> {
    const stageTeams = await this.tournamentApi.getStageTeams(this.tournamentId);
    this.store.save(STORE_TOURNAMENT_STAGE_TEAMS_KEY, stageTeams);
    return stageTeams;
  }
}
